import { useEffect, useRef } from "react";

interface useVideoPlayPauseProps {
  hidden?: boolean;
}

const useVideoPlayPause = ({ hidden = false }: useVideoPlayPauseProps) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (!videoRef?.current) return;

    if (hidden) {
      pauseVideo();
      videoRef.current.style.display = "none";
    }

    if (!hidden) {
      videoRef.current.style.display = "block";
      playVideo();
    }
  }, [hidden]);

  const playVideo = () => {
    if (!videoRef?.current) return;

    videoRef.current.play().catch(() => undefined);
  };

  const pauseVideo = () => {
    if (!videoRef?.current) return;

    videoRef.current.pause();
  };

  return {
    videoRef,
  };
};

export default useVideoPlayPause;
